import { dataReport } from 'dls-icons-data'
import { createIcon } from '../common'

const IconReport = /*#__PURE__*/createIcon(dataReport)
export default IconReport
